<ng-container *ngIf="currentView === ReportingViews.Main">
	<h3 class="ui header">
		<i class="chart pie icon"></i>
		<div class="content">
			Reports
		</div>
	</h3>
	<br />


	<div class="ui stackable grid">
		<div class="row">
			<div class="column">
				<div class="ui icon input">
					<i class="search link icon" (click)="search()"></i>
					<input type="text"
						placeholder="Search..."
						[(ngModel)]="mainPagedQueryModel.searchBy"
						(keydown.enter)="search()"
						app-trim>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="column">
				<div app-loading [enabled]="!tableDataReady" class="ui form">
					<div class="field">
						<app-table-view
							[itemTemplate]="reportingItemTemplate"
							[data]="tableData"
							[dataReady]="tableDataReady"
							[columns]="tableColumns"
							[noSearch]="true"
							[useServerPagination]="true"
							[pageSize]="mainPagination.pageSize"
							[currentPage]="mainPagination.currentPage"
							[totalPages]="mainPagination.totalPages"
							(pageChangeEvent)="mainPageChange($event)">
						</app-table-view>
					</div>
				</div>

				<ng-template #reportingItemTemplate let-item="item">
					<tr style="text-align: center;">
						<td>
							<a href="javascript:void(0);" (click)="onEditAction(item)">{{item.name | dash}}</a>
						</td>
						<td>{{item.description | dash}}</td>
					</tr>
				</ng-template>

			</div>
		</div>
	</div>
</ng-container>

<ng-container *ngIf="currentView === ReportingViews.Report">
	<h3 class="ui header">
		<i class="chart pie icon"></i>
		<div class="content">
			Reports: {{selectedTableItem.name}}
		</div>
	</h3>
	<br />

	<div class="ui stackable grid">
		<div class="row">
			<div class="column">
				<button class="ui basic labeled icon button"
					[disabled]="loading || !reportDataReady"
					(click)="currentView = ReportingViews.Main">
					Back
					<i class="arrow left icon"></i>
				</button>
			</div>
		</div>

		<div app-loading [enabled]="loading" class="row">
			<div class="column">
				<app-report-view
					[isCelled]="true"
					[isSortable]="reportSettings.canSort"
					[isFilterable]="reportSettings.canFilter"
					[hideUnhideColumns]="reportSettings.canHideColumns"
					[isExportable]="reportSettings.canExport"
					[isDraggable]="reportSettings.canReorderColumns"
					[data]="reportData"
					[dataReady]="reportDataReady"
					[columns]="reportColumns"
					[pageSize]="reportsPagination.pageSize"
					[currentPage]="reportsPagination.currentPage"
					[totalPages]="reportsPagination.totalPages"
					(pageChangeEvent)="reportsPageChange($event)"
					(exportExcelEvent)="exportExcelTemplate($event)"
					(pageSizeChangeEvent)="null"
					(sortByColEvent)="sortByCol($event)"
					(filterChangeEvent)="filterChange($event)">
				</app-report-view>
			</div>
		</div>
	</div>
</ng-container>